import { useQuery } from '@apollo/client';

import type { RoleFragment } from 'bundles/onboarding-common/queries/__generated__/RoleFragment';
import InferredRoleQuery from 'bundles/unified-home-common/queries/InferredRoleQuery.graphql';
import type {
  InferredRoleQuery as InferredRoleQueryType,
  InferredRoleQueryVariables,
} from 'bundles/unified-home-common/queries/__generated__/InferredRoleQuery';

type UseGetDefaultInferredRoleReturn = {
  inferredRole: Pick<RoleFragment, 'id' | 'name' | 'slug'> | undefined;
  inferredRoleLoading: boolean;
};

const useGetDefaultInferredRole = (skip: boolean): UseGetDefaultInferredRoleReturn => {
  const { data, loading: inferredRoleLoading } = useQuery<InferredRoleQueryType, InferredRoleQueryVariables>(
    InferredRoleQuery,
    {
      variables: {
        queryCollectionId: 'roles',
        limit: 1,
      },
      context: {
        clientName: 'gatewayGql',
      },
      ssr: true,
      skip,
    }
  );

  const inferredRole = data?.Collection?.queryCollection.entities?.elements?.[0] as
    | Pick<RoleFragment, 'id' | 'name' | 'slug'>
    | undefined;

  return {
    inferredRole,
    inferredRoleLoading,
  };
};

export default useGetDefaultInferredRole;
